<section class="useful-links-section">
  <div class="section section-muted p-0 py-5">
    <div class="container">
      <div class="row d-flex justify-content-center">
        <div class="col-12 col-lg-6">

          <div class="cmp-input-search">
            <div class="form-group autocomplete-wrapper mb-2 mb-lg-4">
              <div class="input-group">
                <label for="autocomplete-autocomplete-three" class="visually-hidden active">Cerca una parola chiave</label>
                <input (keyup.enter)="search()" [(ngModel)]="searchTerm" type="search" class="autocomplete form-control" placeholder="Cerca una parola chiave" id="autocomplete-autocomplete-three" name="autocomplete-three" data-bs-autocomplete="[]" data-focus-mouse="false"><ul class="autocomplete-list"></ul>
          
                <div class="input-group-append">
                  <button (click)="search()" class="btn btn-primary" type="button" id="button-3" data-focus-mouse="false">Invio</button>
                </div>
                
                <span class="autocomplete-icon" aria-hidden="true">
                  <svg class="icon icon-sm icon-primary" aria-label="Cerca">
                    <use href="/bootstrap-italia/dist/svg/sprites.svg#it-search"></use>
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div class="link-list-wrapper ps-4 pt-lg-0 pt-sm-4">
            <div class="link-list-heading text-uppercase mb-3 ps-0">{{data.useful_links_title ?? "Link utili"}}</div>
            <ul class="link-list" *ngIf="data?.useful_links_links.length > 0">
              <li *ngFor="let link of data?.useful_links_links">
                <a class="list-item mb-3 active ps-0" [href]="link?.alias"><span class="text-button-normal">{{link?.title}}</span></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>